import { MCP_RETURN } from '@core/core';
import { isCliReturnUrl } from '@sdk/sdk';
import { environment } from 'src/environments/environment';
import { DeploymentSettings } from './mcp-callback';

const EUROPE_AUTH_ORIGIN = 'https://auth.eu.sytex.io';
const EUROPE_REGION_PREFIX = 'eu-';

/**
 * The same /cli page on the European deployment, or null where the link makes
 * no sense: on that deployment itself, outside production, when `cliUrl` is
 * not this app's /cli page, or when an MCP server opened it.
 *
 * The CLI always opens the US page, and the two regions are separate user
 * pools, so a European account can only sign in over there. Until the page can
 * detect a European session on its own, the user follows this link. An MCP
 * login is not offered it: the European page returns to the European MCP
 * server, which never started this login, so a European account connects
 * through that server instead.
 */
export function europeCliUrl(
  cliUrl: string | null,
  settings: DeploymentSettings = environment
): string | null {
  const isProduction = settings.name === 'production';
  const isEuropeDeployment = settings.cognito.region.startsWith(EUROPE_REGION_PREFIX);
  const isCliPage = isCliReturnUrl(cliUrl, window.location.origin);
  if (!isProduction || isEuropeDeployment || !cliUrl || !isCliPage) {
    return null;
  }
  const url = new URL(cliUrl);
  const isMcpLogin = url.searchParams.get('return') === MCP_RETURN;
  if (isMcpLogin) {
    return null;
  }
  return `${EUROPE_AUTH_ORIGIN}${url.pathname}${url.search}`;
}
